import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { axiosBeelineRequest } from '@beef/utils';

import { API_URL } from 'pages/MainPage/blocks/TariffCardBlock/api/constants';
import { TResponse } from 'pages/MainPage/blocks/TariffCardBlock/api/types';

/** Запрос на получение данных рекомендуемых тарифов  */
export const fetchData = async (config: AxiosRequestConfig): Promise<AxiosResponse<TResponse>> =>
  axiosBeelineRequest({ url: API_URL, method: 'get', ...config });
